"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let TaskStatus = class TaskStatus extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onPoll(...args) {
        return this.$fn
            .fetch('read_invoice_generation_task', { parameters: { id: this.taskId } })
            .then(data => {
            this.setData('item', data);
            return data;
        });
    }
    taskId;
    onTask_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("taskId");
    }
    item;
    pollerInstance;
    async $$load_pollerInstance() {
        return this.$fn.poller({ interval: 3000, callback: this.onPoll }).start();
    }
    ux;
    b_8564662037462133_variantMap;
    b_1889980785424776_options;
    dataMembers = ['item', 'pollerInstance', 'ux', 'b_8564662037462133_variantMap', 'b_1889980785424776_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                pollerInstance: null,
                ux: null,
                b_8564662037462133_variantMap: {
                    PENDING: "warning",
                    STARTED: "primary",
                    FAILURE: "danger",
                },
                b_1889980785424776_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                },
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_5726_getActionArgs_value($event) {
        this.pollerInstance.manualPoll();
    }
    async act_3343864469950044_script_5726_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_5726_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_click(event, scope) {
        return await this.actions.evh_3343864469950044_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_5724 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_5723 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_5724,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_5723],
        });
        const act_3343864469950044_script_5726 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_5726_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_click_5725 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_5726,
            event: "click",
            displayName: "script",
        });
        const evh_3343864469950044_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_click_5725],
        });
        return {
            act_7315092382398562_reloadComponentData_5724,
            evh_7315092382398562_reload_5723,
            evh_7315092382398562_reload,
            act_3343864469950044_script_5726,
            evh_3343864469950044_click_5725,
            evh_3343864469950044_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], TaskStatus.prototype, "taskId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('taskId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TaskStatus.prototype, "onTask_id", null);
TaskStatus = __decorate([
    (0, vue_property_decorator_1.Component)()
], TaskStatus);
exports.default = TaskStatus;
vue_property_decorator_1.Vue.component("TaskStatus", TaskStatus);
